import { useContext } from 'react';

import { MatrixContext } from './MatrixContext';
import { InitialMatrixContextType, MatrixContextType } from './types';

export default function useMatrixContext(): MatrixContextType;
export default function useMatrixContext(options: { requireDefinedMatrixClient: true }): MatrixContextType;
export default function useMatrixContext(options: { requireDefinedMatrixClient: false }): InitialMatrixContextType;

export default function useMatrixContext(options?: {
  requireDefinedMatrixClient?: boolean;
}): InitialMatrixContextType | MatrixContextType {
  const context = useContext(MatrixContext);
  if (!context) throw new Error('useMatrixContext must be used within a MatrixProvider');

  const isMatrixClientRequired = options?.requireDefinedMatrixClient ?? true;

  if (isMatrixClientRequired) {
    if (!context.matrixClient) {
      throw new Error(
        'Matrix client not initialized yet. If this is intentional, pass option requireDefinedMatrixClient: false.'
      );
    }

    return context as MatrixContextType;
  }

  return context as InitialMatrixContextType;
}
